import { FC } from 'react';

import { RentVasBlock } from '@telialt/core-eshop/src/CartSummaryBox/ValueAddedServices';
import { useCartQuery } from '@telialt/core-eshop/src/hooks/queries/useCartQuery';
import { ContractType } from '@telialt/models/src/EshopModel';
import {
    selectHasMultipleContractTypesAvailable,
    selectHasWithPlanContractType,
    selectIsSapRatePlanOffersActive,
    selectPossibleSapRatePlans,
} from '@telialt/utils/src/eshopSelectors';
import { TeliaSegment, useSegment } from '@telialt/utils/src/segment';

import { ContractTypeSelector } from '../ContractTypeSelector/ContractTypeSelector';
import { LeasingPlanSelector, PredefinedLeasingSelector } from '../LeasingPlanSelector';
import { OldRatePlanSelector, SapRatePlanSelector } from '../RatePlanSelector';
import { RentPlanSelector } from '../RentPlanSelector/RentPlanSelector';

export const PaymentOptionsSelectors: FC = () => {
    const segment = useSegment();

    const { cart } = useCartQuery();

    const isWithPlan = cart.contractType === ContractType.WithPlan;
    const isWithoutPlan = cart.contractType === ContractType.WithoutPlan;
    const isRenting = cart.contractType === ContractType.Renting;
    const isSapRatePlanOffersActive = selectIsSapRatePlanOffersActive(cart);
    const hasSapRatePlans = selectPossibleSapRatePlans(cart)?.length > 0;
    const isMultipleContractTypesAvailable = selectHasMultipleContractTypesAvailable(cart);
    const hasWithPlanContractType = selectHasWithPlanContractType(cart);

    const hasSapRatePlanSelector = hasWithPlanContractType && isSapRatePlanOffersActive && hasSapRatePlans;
    const hasContractTypeSelector =
        isMultipleContractTypesAvailable && !isSapRatePlanOffersActive && !hasSapRatePlanSelector;
    const hasOldRatePlanSelector = isWithPlan && !isSapRatePlanOffersActive && !hasSapRatePlanSelector;
    const hasRentPlanSelector = isRenting && segment === TeliaSegment.B2b;
    const hasLeasingSelector = isWithPlan || isWithoutPlan;
    const hasLeasingPlanSelector = hasLeasingSelector && segment === TeliaSegment.B2b;
    const hasPredefinedLeasingSelector = hasLeasingSelector && !hasLeasingPlanSelector;

    return (
        <>
            {hasSapRatePlanSelector && <SapRatePlanSelector />}
            {hasContractTypeSelector && <ContractTypeSelector />}
            {hasOldRatePlanSelector && <OldRatePlanSelector />}
            {hasRentPlanSelector && (
                <>
                    <RentPlanSelector />
                    <RentVasBlock />
                </>
            )}
            {hasLeasingPlanSelector && <LeasingPlanSelector />}
            {hasPredefinedLeasingSelector && <PredefinedLeasingSelector />}
        </>
    );
};
